import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

const LpHeader = ({ order, questionsCount, altStepStyle }) => (
  <>
    <div className="lp-survey-step-padding">
      <strong className={classNames('text-center', { 'c-kale-500': !altStepStyle })}>
        {!altStepStyle && 'Step'} {order} of {questionsCount}
      </strong>
    </div>
  </>
);

LpHeader.propTypes = {
  order: PropTypes.number.isRequired,
  questionsCount: PropTypes.number.isRequired,
  altStepStyle: PropTypes.bool,
};

LpHeader.defaultProps = {
  altStepStyle: false,
};

export default LpHeader;
